import { render, staticRenderFns } from "./PlaylistItemDisplayPriority.vue?vue&type=template&id=8baa11e6&scoped=true"
import script from "./PlaylistItemDisplayPriority.vue?vue&type=script&lang=js"
export * from "./PlaylistItemDisplayPriority.vue?vue&type=script&lang=js"
import style0 from "./PlaylistItemDisplayPriority.vue?vue&type=style&index=0&id=8baa11e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baa11e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8baa11e6')) {
      api.createRecord('8baa11e6', component.options)
    } else {
      api.reload('8baa11e6', component.options)
    }
    module.hot.accept("./PlaylistItemDisplayPriority.vue?vue&type=template&id=8baa11e6&scoped=true", function () {
      api.rerender('8baa11e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PlaylistItemDisplayPriority.vue"
export default component.exports